import * as openpgp from "openpgp";
import {PrivateKey} from "openpgp";

const privateKeyCache: {
  [armored: string]: PrivateKey,
} = {}

const decryptMessage = async (data: string, armoredKey: string) => {
  if (typeof privateKeyCache[armoredKey] === 'undefined') {
    // console.log('read key', armoredKey.substring(0, 100))
    privateKeyCache[armoredKey] = await openpgp.readPrivateKey({ armoredKey })
  // } else {
  //   console.log('decrypt with known key', armoredKey.substring(0, 100))
  }

  const message = await openpgp.readMessage({ armoredMessage: data })

  try {
    const { data: decrypted } = await openpgp.decrypt({
      message,
      decryptionKeys: privateKeyCache[armoredKey],
      format: 'utf8'
    })

    return decrypted
  } catch (e) {
    console.error('failed to decrypt message', e, { data })
  }

  return ''
}

export default decryptMessage